
import { defineComponent } from "vue";
import { mapState } from 'pinia';
import { StatsOption, StatsOptionPolicyEnum, STATS_OPTION } from './widget-more-information.conf';
import moment from "moment";
import { useDashboardStore } from "~/store/dashboard.store";
import WidgetContentBase from '~/components/widgets/widget-content-base';
import { StationStats } from "~/api/models/station-stats.model";

const fake: StationStats = {
    period: {
        since: moment().subtract(1, 'w').unix(),
        before: moment().unix()
    },
    data: {
        'CO2': {
            min: 450,
            min_date: moment().subtract(10, 'h').unix(),
            max: 1200,
            max_date: moment().subtract(23, 'h').unix(),
            mean: 842,
            distribution: {

            }
        }
    },
}

export default defineComponent({

    extends: WidgetContentBase,

    computed: {
        ...mapState(useDashboardStore, ['currentStation', 'indicator', 'stats', 'mode']),

        data(): StationStats {
            return this.fake ? fake: this.stats;
        },

        selectedIndicator(): string {
            return this.fake ? 'CO2': this.indicator;
        },

        selectedMode(): string {
            return this.fake ? 'week': this.mode;
        },

        min(): string {
            return this.data?.data[this.selectedIndicator]?.min?.toFixed(0) || '-';
        },

        minDate(): string {
            const date = this.data?.data[this.selectedIndicator]?.min_date;
            return moment.unix(date).format('lll');
        },

        unit(): string {
            
            const unit = this.currentStation?.latest_values_units[this.selectedIndicator] || ''
            return this.fake ? 'ppm' : unit === 'degC' ? '°C' : unit;
        },

        max(): string {
            return this.data?.data[this.selectedIndicator]?.max.toFixed(0) || '-';
        },

        maxDate(): string {
            const date = this.data?.data[this.selectedIndicator]?.max_date
            return moment.unix(date).format('lll');
        },

        mean(): string {
            return this.data?.data[this.selectedIndicator]?.mean.toFixed(0) || '-';
        },

        statsOptions(): StatsOption {
            return STATS_OPTION[this.selectedIndicator];
        },

        empty(): boolean {
            return !this.editable && (!this.data || !this.data.data[this.selectedIndicator]);
        }
    },

    methods: {
        itemTitle(index: number) {
            const option: StatsOption = this.statsOptions;
            const statsOption = option && option.stats;
            let titlesByOptions = null;
            switch (statsOption) {
                case StatsOptionPolicyEnum.LOWEST_IS_BETTER:
                    titlesByOptions = {
                        hour: [this.$t('dashboard.more_widget.best_measure_hour'), this.$t('dashboard.more_widget.average_hour'), this.$t('dashboard.more_widget.worst_measure_hour')],
                        day: [this.$t('dashboard.more_widget.best_measure_day'), this.$t('dashboard.more_widget.average_day'), this.$t('dashboard.more_widget.worst_measure_day')],
                        week: [this.$t('dashboard.more_widget.best_measure_week'), this.$t('dashboard.more_widget.average_week'), this.$t('dashboard.more_widget.worst_measure_week')],
                        month: [this.$t('dashboard.more_widget.best_measure_month'), this.$t('dashboard.more_widget.average_month'), this.$t('dashboard.more_widget.worst_measure_month')]
                    };
                    break;

                case StatsOptionPolicyEnum.QUANTITATIVE:
                default:
                    titlesByOptions = {
                        hour: [this.$t('dashboard.more_widget.lowest_measure_hour'), this.$t('dashboard.more_widget.average_hour'), this.$t('dashboard.more_widget.highest_measure_hour')],
                        day: [this.$t('dashboard.more_widget.lowest_measure_day'), this.$t('dashboard.more_widget.average_day'), this.$t('dashboard.more_widget.highest_measure_day')],
                        week: [this.$t('dashboard.more_widget.lowest_measure_week'), this.$t('dashboard.more_widget.average_week'), this.$t('dashboard.more_widget.highest_measure_week')],
                        month: [this.$t('dashboard.more_widget.lowest_measure_month'), this.$t('dashboard.more_widget.average_month'), this.$t('dashboard.more_widget.highest_measure_month')]
                    };
                    break;
            }

            const titles = titlesByOptions[this.selectedMode];
            return titles[index];
        }
    }
})

